import { OreButton, OreStack, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { Step2Form } from '@/Contract/ui/hooks'

interface ContractNewProductsStep2ActionsProps {
  isEditable?: boolean
  isDocumentEditable?: boolean
}

export const ContractNewProductsStep2Actions = ({
  isEditable,
  isDocumentEditable,
}: ContractNewProductsStep2ActionsProps): JSX.Element => {
  const { t } = useTranslation()

  const { handleSubmit, formState } = useFormContext<Step2Form>()
  const { saveStep2, previousStep, nextStep } = useContractNewProducts()

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton
        data-testid="previous"
        category={'tertiary'}
        icon={<SvgArrowLeft />}
        onClick={previousStep}
      >
        {t(
          productContractingTranslation.contractProductPage.step2.buttons.previous.label,
        )}
      </OreButton>

      <OreButton
        data-testid="next"
        category={'primary'}
        onClick={() => {
          if (!isEditable && !isDocumentEditable) {
            // Go to Next Step when nothing is editable
            nextStep()
          } else {
            handleSubmit(saveStep2)()
          }
        }}
        disabled={isEditable && !formState.isValid}
      >
        {t(productContractingTranslation.contractProductPage.step2.buttons.next.label)}
      </OreButton>
    </OreStack>
  )
}
